<div class="mt-1 py-0 px-1" [ngClass]="templateClass">
  <small>
    {{ templateName }}
  </small>
</div>
